import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { get } from 'lodash-es'
import { chatbotEvents } from '../state'
import { portfolioApiEvents } from 'modules/api/portfolio'

export interface LeaseTermState {
  term: {
    startDate: string
    endDate: string
    rolloverMonthToMonth: boolean
  } | null
}

export const initialState: LeaseTermState = {
  term: null,
}

interface SelectLeaseTermsPayload {
  startDate: string
  endDate: string
  rolloverMonthToMonth: boolean
}

const leaseTermSlice = createSlice({
  name: 'chatbot/dialogs/leaseTerm',
  initialState,
  reducers: {
    selectLeaseTerms: (state, action: PayloadAction<SelectLeaseTermsPayload>) => {
      state.term = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        state.term = get(action.payload, 'leaseTerms', null)
      })
      .addCase(portfolioApiEvents.amendTerms_success, (state, action) => {
        state.term = action.payload.leaseTerms ?? null
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, () => initialState)
  },
})

export const { reducer } = leaseTermSlice
export const leaseTermEvents = leaseTermSlice.actions
